import axios from 'axios';

export default axios.create({
    baseURL: 'https://apps.shelegcrm.com/shelegapi/api/v1.0/',
    headers: {
        Authorization: '',
        'Content-Type': 'application/json'
    },
    
});